import IdCardReaderPendingComponent from 'components/id-card-reader-pending-component/IdCardReaderPendingComponent';

interface IdCardViewProps {
  onCancel: () => void;
  isProcessing: boolean;
}

export const IdCardView = ({ onCancel, isProcessing }: IdCardViewProps) => {
  return (
    <IdCardReaderPendingComponent
      onCancel={onCancel}
      isCancelButtonVisible={!isProcessing}
    />
  );
};
